import { Box, Link, Typography } from '@mui/material';
import React, { useState } from 'react';
import { mapDispatchToProps, mapStateToProps } from './SignUpResend.container';

import { FormikTextField } from '/b2b/common/components/FormControls/TextField';
import FormikValidationForm from '/b2b/common/components/organisms/FormikValidationForm';
import Locale from '/b2b/common/components/Locale';
import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
import UnauthenticatedPaths from '/b2b/routing/UnauthenticatedRoutes/UnauthenticatedRoutes.paths';
import { connect } from 'react-redux';
import { signUpResentSchema } from './SignUpResend.schema';
import useBoundCallback from '/b2b/common/helpers/Hooks/useBoundCallback';

// eslint-disable-next-line no-use-before-define
export default connect(mapStateToProps, mapDispatchToProps)(SignUpResend);

export function SignUpResend(props) {
    const { email, resetAuthState, resetTemporaryPassword } = props;
    const [resent, setResent] = useState('');
    const onSubmit = useBoundCallback(({ email, password }) => {
        return resetTemporaryPassword(email, password).then(({ message = true }) =>
            setResent(message)
        );
    }, []);

    return (
        <Box
            display="flex"
            flexDirection="column"
            height="100%"
            alignItems="stretch"
            justifyContent="center"
            sx={{ mx: 'auto', px: 2, maxWidth: 700, width: '100%' }}
        >
            <FormikValidationForm
                initialValues={{ email }}
                validationSchema={signUpResentSchema}
                onSubmit={onSubmit}
                title="password.expired"
                subtitle="password.newTemporary"
                submitText="password.reset"
                validateOnMount
            >
                <Box
                    display="flex"
                    flexDirection="column"
                    width="100%"
                    flexGrow={1}
                    gap={0.5}
                    alignItems="center"
                    mt={4}
                    mb={1}
                    sx={theme => (theme.breakpoints.down('lg') ? { justifyContent: 'center' } : {})}
                >
                    <FormikTextField
                        name="email"
                        label="common.email"
                        autoComplete="email"
                        fullWidth
                        required
                        mb={1}
                    />
                </Box>
            </FormikValidationForm>
            <Box mt={5}>
                <Typography color={resent === true ? 'primary' : 'error'} variant="body2">
                    {resent === true ? <Locale path="password.sent" /> : resent}
                </Typography>
                <Typography variant="body1">
                    <Locale path="common.backTo" />{' '}
                    <Link
                        fontWeight="bold"
                        component={RouterLink}
                        onClick={resetAuthState}
                        to={UnauthenticatedPaths.SIGN_IN}
                    >
                        <Locale path="common.signIn" />
                    </Link>
                </Typography>
            </Box>
        </Box>
    );
}

SignUpResend.propTypes = {
    email: PropTypes.string,
    resetAuthState: PropTypes.func.isRequired,
    resetTemporaryPassword: PropTypes.func.isRequired,
};
